module.exports = __webpack_public_path__ + "img/emplogopic.1c943c2e.svg";